import type { ColDef } from 'ag-grid-enterprise';

import { idRenderer } from '@/utils/GridRenderer.utils';

import type { ResponseActionSummaryDTO } from './MsDefenderIntegration.types';
import { renderResponseActionStatusCell } from './ResponseActionHistoryDialog.renderers';
import {
  formatHistoryActionType,
  formatHistoryTimestamp
} from './ResponseActionHistoryDialog.utils';

export const RESPONSE_ACTION_HISTORY_COLUMN_DEFS: ColDef<ResponseActionSummaryDTO>[] =
  [
    {
      field: 'created_at',
      headerName: 'Timestamp',
      maxWidth: 180,
      minWidth: 180,
      valueFormatter: ({ value }) => formatHistoryTimestamp(value)
    },
    {
      field: 'action_type',
      headerName: 'Action',
      minWidth: 170,
      valueFormatter: ({ value }) => formatHistoryActionType(value)
    },
    {
      field: 'target',
      headerName: 'Target',
      minWidth: 200,
      flex: 1,
      valueFormatter: ({ value }) => value ?? '—'
    },
    {
      field: 'soc_id',
      headerName: 'Case',
      minWidth: 120,
      maxWidth: 120,
      cellRenderer: idRenderer,
      cellRendererParams: { path: '/case', colorAnchor: true }
    },
    {
      field: 'current_status',
      headerName: 'Status',
      maxWidth: 120,
      minWidth: 120,
      cellRenderer: renderResponseActionStatusCell
    },
    {
      headerName: 'Details / Reason',
      minWidth: 300,
      flex: 2,
      wrapText: true,
      autoHeight: true,
      cellStyle: {
        lineHeight: 'normal',
        paddingTop: '0.5rem',
        paddingBottom: '0.5rem'
      },
      valueGetter: ({ data }) => data?.detail || data?.status_reason || '—'
    }
  ];
